// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.sidebar-right {
  position: absolute;
  top: 0;
  z-index: 500;
  right: 0;
  color: #fff;
  height: 100%;
  width: 360px;
  opacity: 0.92;
  padding-top: 130px;
  overflow: auto;
  scrollbar-width: none;
  background-color: #0b1736;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2); }
  .sidebar-right .right-header-component {
    top: 135px !important;
    right: 60px !important; }
    .sidebar-right .right-header-component .btn-right-menu-component {
      background-color: unset; }
  .sidebar-right tr:nth-child(2) .form-check-input:checked {
    background-color: #0692AE; }
  .sidebar-right tr:nth-child(3) .form-check-input:checked {
    background-color: #daa520; }
  .sidebar-right tr:nth-child(4) .form-check-input:checked {
    background-color: #f04f23; }
  .sidebar-right tr:nth-child(5) .form-check-input:checked {
    background-color: green; }
  .sidebar-right tr:nth-child(6) .form-check-input:checked {
    background-color: gray; }
  .sidebar-right tr:nth-child(7) .form-check-input:checked {
    background-color: #bedb9c; }
  .sidebar-right tr:nth-child(8) .form-check-input:checked {
    background-color: #42c8f4; }
  .sidebar-right button.thumbnail {
    background-color: #fff;
    width: 70px;
    height: 70px;
    border-radius: 15px;
    margin-bottom: 15px; }
    .sidebar-right button.thumbnail img {
      width: 50px;
      transform: translateX(-2px); }
    .sidebar-right button.thumbnail:hover {
      background-color: #e0e0e0; }
  .sidebar-right button.new-thumbnail {
    background-color: transparent;
    width: 70px;
    height: 70px;
    border-radius: 15px;
    margin-bottom: 15px;
    border-style: dashed;
    border-width: 2px;
    border-color: silver; }
    .sidebar-right button.new-thumbnail img {
      width: 10px; }
  .sidebar-right .sidebar-right-header {
    padding-left: 15px; }
  .sidebar-right #rightSidebarTabs {
    max-height: calc(100vh - 270px); }
  .sidebar-right .tab-content {
    max-height: calc(100vh - 270px); }
  .sidebar-right .table-container {
    width: 330px;
    text-align: center;
    padding-left: 20px;
    position: relative;
    margin-top: 20px;
    overflow-y: auto;
    max-height: calc(100vh - 270px); }
    .sidebar-right .table-container table {
      width: 100%; }
      .sidebar-right .table-container table td.description {
        text-align: center;
        width: 158px;
        padding-right: 10px; }
        .sidebar-right .table-container table td.description .description {
          font-size: 14px;
          vertical-align: text-top;
          margin-top: -15px;
          margin-left: 10px; }
      .sidebar-right .table-container table .sidebar-right-button {
        width: 80px; }
      .sidebar-right .table-container table td.check input {
        margin-top: -6px;
        cursor: pointer; }
      .sidebar-right .table-container table td.check input::before {
        background-color: red !important; }
  .sidebar-right hr {
    margin-top: 50px;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1); }

.image-icon {
  width: 90px !important;
  transform: translateX(-22px) !important; }

#sidebar-image-icon-agWaterTrueQI {
  transform: translate(-21px, -6px) !important; }

#sidebar-image-icon-drinkingWaterQuality {
  width: 40px !important;
  transform: translateX(0px) !important; }

#sidebar-image-icon-h303D {
  width: 55px !important;
  transform: translateX(-7px) !important; }

.sidebar-right::-webkit-scrollbar {
  display: none; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/sidebar-right.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,QAAQ;EACR,WDPqB;ECQrB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAElB,cAAc;EACd,qBAAqB;EACrB,yBDVkC;ECWlC,2CAA2C,EAAA;EAd7C;IAiBI,qBAAqB;IACrB,sBAAsB,EAAA;IAlB1B;MAqBM,uBAAuB,EAAA;EArB7B;IA2BM,yBAAyB,EAAA;EA3B/B;IAiCM,yBAAyB,EAAA;EAjC/B;IAuCM,yBAAyB,EAAA;EAvC/B;IA6CM,uBAAuB,EAAA;EA7C7B;IAmDM,sBAAsB,EAAA;EAnD5B;IAyDM,yBAAyB,EAAA;EAzD/B;IA+DM,yBAAyB,EAAA;EA/D/B;IAoEI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB,EAAA;IAxEvB;MA2EM,WAAW;MACX,2BAA2B,EAAA;IA5EjC;MAgFM,yBAAyB,EAAA;EAhF/B;IAqFI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB,EAAA;IA5FxB;MA+FM,WAAW,EAAA;EA/FjB;IAoGI,kBAAkB,EAAA;EApGtB;IAwGI,+BAA+B,EAAA;EAxGnC;IA4GI,+BAA+B,EAAA;EA5GnC;IAgHI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B,EAAA;IAtHnC;MAyHM,WAAW,EAAA;MAzHjB;QA4HQ,kBAAkB;QAClB,YAAY;QACZ,mBAAmB,EAAA;QA9H3B;UAiIU,eAAe;UACf,wBAAwB;UACxB,iBAAiB;UACjB,iBAAiB,EAAA;MApI3B;QAyIQ,WAAW,EAAA;MAzInB;QAgJU,gBAAgB;QAChB,eAAe,EAAA;MAjJzB;QAoJU,gCAAgC,EAAA;EApJ1C;IA2JI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,wCAAwC,EAAA;;AAI5C;EACE,sBAAsB;EACtB,uCAAuC,EAAA;;AAGzC;EACE,4CAA4C,EAAA;;AAG9C;EACE,sBAAsB;EACtB,qCAAqC,EAAA;;AAGvC;EACE,sBAAsB;EACtB,sCAAsC,EAAA;;AAGxC;EACE,aAAa,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../theme/_variables.scss\";\n\n.sidebar-right {\n  position: absolute;\n  top: 0;\n  z-index: 500;\n  right: 0;\n  color: $primaryFontColor;\n  height: 100%;\n  width: 360px;\n  opacity: 0.92;\n  padding-top: 130px;\n  \n  overflow: auto;\n  scrollbar-width: none;\n  background-color: $sideSubMenuBackgroundColor;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n\n  .right-header-component {\n    top: 135px !important;\n    right: 60px !important;\n\n    .btn-right-menu-component {\n      background-color: unset;\n    }\n  }\n\n  tr:nth-child(2) {\n    .form-check-input:checked {\n      background-color: #0692AE;\n    }\n  }\n\n  tr:nth-child(3) {\n    .form-check-input:checked {\n      background-color: #daa520;\n    }\n  }\n\n  tr:nth-child(4) {\n    .form-check-input:checked {\n      background-color: #f04f23;\n    }\n  }\n\n  tr:nth-child(5) {\n    .form-check-input:checked {\n      background-color: green;\n    }\n  }\n\n  tr:nth-child(6) {\n    .form-check-input:checked {\n      background-color: gray; \n    }\n  }\n\n  tr:nth-child(7) {\n    .form-check-input:checked {\n      background-color: #bedb9c;\n    }\n  }\n\n  tr:nth-child(8) {\n    .form-check-input:checked {\n      background-color: #42c8f4;\n    }\n  }\n\n  button.thumbnail {\n    background-color: #fff;\n    width: 70px;\n    height: 70px;\n    border-radius: 15px;\n    margin-bottom: 15px;\n\n    img {\n      width: 50px;\n      transform: translateX(-2px);\n    }\n\n    &:hover {\n      background-color: #e0e0e0;\n    }\n  }\n\n  button.new-thumbnail {\n    background-color: transparent;\n    width: 70px;\n    height: 70px;\n    border-radius: 15px;\n    margin-bottom: 15px;\n    border-style: dashed;\n    border-width: 2px;\n    border-color: silver;\n\n    img {\n      width: 10px;\n    }\n  }\n\n  .sidebar-right-header {\n    padding-left: 15px;\n  }\n\n  #rightSidebarTabs {\n    max-height: calc(100vh - 270px);\n  }\n\n  .tab-content {\n    max-height: calc(100vh - 270px);\n  }\n\n  .table-container {\n    width: 330px;\n    text-align: center;\n    padding-left: 20px;\n    position: relative;\n    margin-top: 20px;\n    overflow-y: auto;\n    max-height: calc(100vh - 270px);\n\n    table {\n      width: 100%;\n\n      td.description {\n        text-align: center;\n        width: 158px;\n        padding-right: 10px;\n\n        .description {\n          font-size: 14px;\n          vertical-align: text-top;\n          margin-top: -15px;\n          margin-left: 10px;\n        }\n      }\n\n      .sidebar-right-button {\n        width: 80px;\n      }\n\n      td.check {\n        //vertical-align: text-top;\n\n        input {\n          margin-top: -6px;\n          cursor: pointer;\n        }\n        input::before {\n          background-color: red !important;\n        }\n      }\n    }\n  }\n\n  hr {\n    margin-top: 50px;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n}\n\n.image-icon {\n  width: 90px !important;\n  transform: translateX(-22px) !important;\n}\n\n#sidebar-image-icon-agWaterTrueQI {\n  transform: translate(-21px, -6px) !important;\n}\n\n#sidebar-image-icon-drinkingWaterQuality {\n  width: 40px !important;\n  transform: translateX(0px) !important;\n}\n\n#sidebar-image-icon-h303D {\n  width: 55px !important;\n  transform: translateX(-7px) !important;\n}\n\n.sidebar-right::-webkit-scrollbar {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
